import type { ResponderActionsAccordionSection } from '@buxus/shared'
import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'
import { trackRichHtmlLinkClick } from './platform/analytics/interactionAnalytics'
import { BuxusAccordion } from './components/BuxusAccordion'

type Props = {
  sections: ResponderActionsAccordionSection[]
  analytics?: ScreenInteractionContext
}

/** Mobile Responder Actions accordion parity (911 Dispatch, Fire Service, …). */
export function ResponderActionsAccordions({ sections, analytics }: Props) {
  const defaultExpandedIds = sections.length === 1 ? [sections[0]!.id] : undefined

  return (
    <BuxusAccordion
      className="responder-actions-accordion"
      defaultExpandedIds={defaultExpandedIds}
      analytics={analytics}
      items={sections.map((section) => ({
        id: section.id,
        title: section.title,
        content: (
          <div
            className="rich responder-actions-accordion-body"
            dangerouslySetInnerHTML={{ __html: section.html }}
            onClick={analytics ? (e) => trackRichHtmlLinkClick(e, analytics) : undefined}
          />
        ),
      }))}
    />
  )
}
